"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEGACY_PROPERTY_OPERATORS = exports.PROPERTY_OPERATORS = exports.OPERATORS = exports.STARTS_WITH = exports.NOT_STARTS_WITH = exports.NOT_KNOWN = exports.NOT_ENDS_WITH = exports.NOT_CONTAINS = exports.KNOWN = exports.IS_NOT_ANY_OF = exports.IS_NOT = exports.IS_ANY_OF = exports.IS = exports.FQDN_SUFFIX_MATCH = exports.FQDN_SUBDOMAIN_MATCH = exports.FQDN_MATCH = exports.FQDN_BRAND_MATCH = exports.ENDS_WITH = exports.CONTAINS = exports.PROPERTIES_PRE_BRAND_DOMAINS = exports.PROPERTIES = exports.URL_PATH_AND_QUERY_CONTAINS = exports.URL_PATH_AND_QUERY_STARTS = exports.URL_PATH_AND_QUERY = exports.FQDN_SUFFIX = exports.FQDN_SUBDOMAIN = exports.FQDN_BRAND = exports.FQDN = exports.COUNTRY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PROPERTY_OPERATORS, _LEGACY_PROPERTY_OPER;

var COUNTRY = 'COUNTRY';
exports.COUNTRY = COUNTRY;
var FQDN = 'FQDN';
exports.FQDN = FQDN;
var FQDN_BRAND = 'FQDN_BRAND';
exports.FQDN_BRAND = FQDN_BRAND;
var FQDN_SUBDOMAIN = 'FQDN_SUBDOMAIN';
exports.FQDN_SUBDOMAIN = FQDN_SUBDOMAIN;
var FQDN_SUFFIX = 'FQDN_SUFFIX';
exports.FQDN_SUFFIX = FQDN_SUFFIX;
var URL_PATH_AND_QUERY = 'URL_PATH_AND_QUERY';
exports.URL_PATH_AND_QUERY = URL_PATH_AND_QUERY;
var URL_PATH_AND_QUERY_STARTS = 'URL_PATH_AND_QUERY_STARTS';
exports.URL_PATH_AND_QUERY_STARTS = URL_PATH_AND_QUERY_STARTS;
var URL_PATH_AND_QUERY_CONTAINS = 'URL_PATH_AND_QUERY_CONTAINS';
exports.URL_PATH_AND_QUERY_CONTAINS = URL_PATH_AND_QUERY_CONTAINS;
var PROPERTIES = [COUNTRY, FQDN_SUBDOMAIN, FQDN_BRAND, FQDN_SUFFIX, URL_PATH_AND_QUERY];
exports.PROPERTIES = PROPERTIES;
var PROPERTIES_PRE_BRAND_DOMAINS = [COUNTRY, FQDN, URL_PATH_AND_QUERY];
exports.PROPERTIES_PRE_BRAND_DOMAINS = PROPERTIES_PRE_BRAND_DOMAINS;
var CONTAINS = 'CONTAINS';
exports.CONTAINS = CONTAINS;
var ENDS_WITH = 'ENDS_WITH';
exports.ENDS_WITH = ENDS_WITH;
var FQDN_BRAND_MATCH = 'FQDN_BRAND_MATCH';
exports.FQDN_BRAND_MATCH = FQDN_BRAND_MATCH;
var FQDN_MATCH = 'FQDN_MATCH';
exports.FQDN_MATCH = FQDN_MATCH;
var FQDN_SUBDOMAIN_MATCH = 'FQDN_SUBDOMAIN_MATCH';
exports.FQDN_SUBDOMAIN_MATCH = FQDN_SUBDOMAIN_MATCH;
var FQDN_SUFFIX_MATCH = 'FQDN_SUFFIX_MATCH';
exports.FQDN_SUFFIX_MATCH = FQDN_SUFFIX_MATCH;
var IS = 'IS';
exports.IS = IS;
var IS_ANY_OF = 'IS_ANY_OF';
exports.IS_ANY_OF = IS_ANY_OF;
var IS_NOT = 'IS_NOT';
exports.IS_NOT = IS_NOT;
var IS_NOT_ANY_OF = 'IS_NOT_ANY_OF';
exports.IS_NOT_ANY_OF = IS_NOT_ANY_OF;
var KNOWN = 'KNOWN';
exports.KNOWN = KNOWN;
var NOT_CONTAINS = 'NOT_CONTAINS';
exports.NOT_CONTAINS = NOT_CONTAINS;
var NOT_ENDS_WITH = 'NOT_ENDS_WITH';
exports.NOT_ENDS_WITH = NOT_ENDS_WITH;
var NOT_KNOWN = 'NOT_KNOWN';
exports.NOT_KNOWN = NOT_KNOWN;
var NOT_STARTS_WITH = 'NOT_STARTS_WITH';
exports.NOT_STARTS_WITH = NOT_STARTS_WITH;
var STARTS_WITH = 'STARTS_WITH';
exports.STARTS_WITH = STARTS_WITH;
var OPERATORS = [CONTAINS, ENDS_WITH, FQDN_BRAND_MATCH, FQDN_MATCH, FQDN_SUBDOMAIN_MATCH, FQDN_SUFFIX_MATCH, IS_ANY_OF, IS_NOT_ANY_OF, IS_NOT, IS, KNOWN, NOT_CONTAINS, NOT_ENDS_WITH, NOT_KNOWN, NOT_STARTS_WITH, STARTS_WITH];
exports.OPERATORS = OPERATORS;
var PROPERTY_OPERATORS = (_PROPERTY_OPERATORS = {}, (0, _defineProperty2.default)(_PROPERTY_OPERATORS, COUNTRY, [IS, IS_NOT, IS_ANY_OF, IS_NOT_ANY_OF, KNOWN, NOT_KNOWN]), (0, _defineProperty2.default)(_PROPERTY_OPERATORS, FQDN_SUBDOMAIN, [FQDN_SUBDOMAIN_MATCH]), (0, _defineProperty2.default)(_PROPERTY_OPERATORS, FQDN_BRAND, [FQDN_BRAND_MATCH]), (0, _defineProperty2.default)(_PROPERTY_OPERATORS, FQDN_SUFFIX, [FQDN_SUFFIX_MATCH]), (0, _defineProperty2.default)(_PROPERTY_OPERATORS, URL_PATH_AND_QUERY_STARTS, [STARTS_WITH, NOT_STARTS_WITH]), (0, _defineProperty2.default)(_PROPERTY_OPERATORS, URL_PATH_AND_QUERY_CONTAINS, [CONTAINS, NOT_CONTAINS]), _PROPERTY_OPERATORS); // legacy

exports.PROPERTY_OPERATORS = PROPERTY_OPERATORS;
var URL = 'URL';
var DOMAIN = 'DOMAIN';
var LEGACY_PROPERTY_OPERATORS = (_LEGACY_PROPERTY_OPER = {}, (0, _defineProperty2.default)(_LEGACY_PROPERTY_OPER, URL, [CONTAINS]), (0, _defineProperty2.default)(_LEGACY_PROPERTY_OPER, DOMAIN, [CONTAINS]), _LEGACY_PROPERTY_OPER);
exports.LEGACY_PROPERTY_OPERATORS = LEGACY_PROPERTY_OPERATORS;